import { type JSONData } from "../../base_classes/dto.d";
import { Dto } from "../../base_classes/dto";
import { type IPortalEventStatsDto } from "./dto.gen.d";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

// ENUMS
export enum PortalEventType {
  CREATED = "Created",
  UPDATED = "Updated",
  DELETED = "Deleted",
  NEW = "New",
  PUSH = "Push",
  RESET = "Reset",
  PRINT = "Print",
  PRINTLABEL = "PrintLabel",
  EMAILSENT = "EmailSent",
  EMAILRECEIVED = "EmailReceived",
  ERROR = "Error",
  STATUSUPDATE = "StatusUpdate",
  SENTTOAFAS = "SentToAfas",
}
export const PortalEventTypeValues = Object.values(PortalEventType);
export const toPortalEventType = (s: string): PortalEventType => {
  switch (s) {
    case "Created":
      return PortalEventType.CREATED;
    case "Updated":
      return PortalEventType.UPDATED;
    case "Deleted":
      return PortalEventType.DELETED;
    case "New":
      return PortalEventType.NEW;
    case "Push":
      return PortalEventType.PUSH;
    case "Reset":
      return PortalEventType.RESET;
    case "Print":
      return PortalEventType.PRINT;
    case "PrintLabel":
      return PortalEventType.PRINTLABEL;
    case "EmailSent":
      return PortalEventType.EMAILSENT;
    case "EmailReceived":
      return PortalEventType.EMAILRECEIVED;
    case "Error":
      return PortalEventType.ERROR;
    case "StatusUpdate":
      return PortalEventType.STATUSUPDATE;
    case "SentToAfas":
      return PortalEventType.SENTTOAFAS;
    default:
      return PortalEventType.CREATED;
  }
};
export enum AggregationInterval {
  DAY = "Day",
  WEEK = "Week",
  MONTH = "Month",
  YEAR = "Year",
}
export const AggregationIntervalValues = Object.values(AggregationInterval);
export const toAggregationInterval = (s: string): AggregationInterval => {
  switch (s) {
    case "Day":
      return AggregationInterval.DAY;
    case "Week":
      return AggregationInterval.WEEK;
    case "Month":
      return AggregationInterval.MONTH;
    case "Year":
      return AggregationInterval.YEAR;
    default:
      return AggregationInterval.DAY;
  }
};

export class PortalEventStatsDto extends Dto implements IPortalEventStatsDto {
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/portal_event_stats/{id}";
  _reference = "/PortalEventStats/{id}";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////

  aggregationInterval = AggregationInterval.DAY;

  count = 0;

  date = "";

  entityName = "";

  fromTimestamp = 0;

  _kind = "PortalEventStats";

  month = 0;

  timestamp = 0;

  timezone = 0;

  toTimestamp = 0;

  type = PortalEventType.UPDATED;

  week = 0;

  weekDay = 0;

  year = 0;

  /// ///////////////////////////////////////
  /// ///////////// METHODS /////////////////
  /// ///////////////////////////////////////

  static FromJSON(data: unknown): PortalEventStatsDto {
    // Create a new instance of the class
    const obj = new PortalEventStatsDto();
    obj.set(data as JSONData);
    return obj;
  }

  static FromJSONArray(data: unknown[]): PortalEventStatsDto[] {
    return data.map((item) => PortalEventStatsDto.FromJSON(item));
  }

  override set(data: JSONData): void {
    super.set(data);

    // Implement variables here
    if (
      data.aggregationInterval !== undefined &&
      data.aggregationInterval !== null
    ) {
      this.aggregationInterval = toAggregationInterval(
        (data?.aggregationInterval as string) ?? this.aggregationInterval,
      );
    }
    if (data.count !== undefined && data.count !== null) {
      this.count = (data.count as number) ?? this.count;
    }
    if (data.date !== undefined && data.date !== null) {
      this.date = (data.date as string) ?? this.date;
    }
    if (data.entityName !== undefined && data.entityName !== null) {
      this.entityName = (data.entityName as string) ?? this.entityName;
    }
    if (data.fromTimestamp !== undefined && data.fromTimestamp !== null) {
      this.fromTimestamp = (data.fromTimestamp as number) ?? this.fromTimestamp;
    }
    if (data._kind !== undefined && data._kind !== null) {
      this._kind = (data._kind as string) ?? this._kind;
    }
    if (data.month !== undefined && data.month !== null) {
      this.month = (data.month as number) ?? this.month;
    }
    if (data.timestamp !== undefined && data.timestamp !== null) {
      this.timestamp = (data.timestamp as number) ?? this.timestamp;
    }
    if (data.timezone !== undefined && data.timezone !== null) {
      this.timezone = (data.timezone as number) ?? this.timezone;
    }
    if (data.toTimestamp !== undefined && data.toTimestamp !== null) {
      this.toTimestamp = (data.toTimestamp as number) ?? this.toTimestamp;
    }
    if (data.type !== undefined && data.type !== null) {
      this.type = toPortalEventType((data?.type as string) ?? this.type);
    }
    if (data.week !== undefined && data.week !== null) {
      this.week = (data.week as number) ?? this.week;
    }
    if (data.weekDay !== undefined && data.weekDay !== null) {
      this.weekDay = (data.weekDay as number) ?? this.weekDay;
    }
    if (data.year !== undefined && data.year !== null) {
      this.year = (data.year as number) ?? this.year;
    }
  }
}
